module.exports = __webpack_public_path__ + "media/images/abuse-per-adult-1bcc7a7b19cb26d0f6cd03071341f88e.png";